export default {"src":"/_next/static/media/EmojiIcon.c3a8435a.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};